import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { useTranslation } from "react-i18next";


// PageIndicator component:
// Displays the current page number and total number of pages,
// fixed in the bottom-left corner of the viewer.
// Props:
// - currentPage: the currently visible page (1-based index)
// - numPages: total number of pages in the PDF
function PageIndicator({ currentPage, numPages }) {
    const { t } = useTranslation();

    const theme = useTheme();

    return (
        // A positioned container for the page indicator
        <Box
            bgcolor={alpha(theme.palette.background.default, 0.8)}
            sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                boxShadow: 1,
            }}
        >
            <Typography variant="body2" color={theme.palette.text.primary} sx={{ whiteSpace: 'nowrap' }}>
                {t("page")} {currentPage}  {t("of")} {numPages}
            </Typography>
        </Box>
    );
}

export default PageIndicator;
